// Desc: Constants for the chat widget
export const CHAT_WIDGET_ID = "sparkfire-chat-widget"
export const CHAT_FRAME_WIDGET_ID = "sparkfire-chat-frame-widget"
export const BTN_TRIGGER_CHAT_ID = "sparkfire-btn-trigger-chat"